import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable()

export class HeaderLayoutService {
    public title = new Subject<any>();

    constructor(
    ) { }

    setHeaderTitle(titleName) {
        this.title.next(titleName);
    }

    getHeaderTitle() {
        return this.title.asObservable();
    }
}
